import _regeneratorRuntime from "/var/lib/jenkins/workspace/qbo-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import { combineReducers } from 'redux';
import React, { Component, useState, useCallback, createContext, useContext, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var TOGGLE_MODAL = 'TOGGLE_MODAL';
var UPDATE_MODAL_LAYER_CONTENT = 'UPDATE_MODAL_LAYER_CONTENT';
var PUSH_MODAL_LAYER = 'PUSH_MODAL_LAYER';
var POP_MODAL_LAYER = 'POP_MODAL_LAYER';

var toggleModal = function toggleModal(content) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dispatch) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", dispatch({
                  type: TOGGLE_MODAL,
                  payload: content
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

var updateModalLayerContent = function updateModalLayerContent(content) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(dispatch) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", dispatch({
                  type: UPDATE_MODAL_LAYER_CONTENT,
                  payload: content
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};

var pushModalLayer = function pushModalLayer(content) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(dispatch) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", dispatch({
                  type: PUSH_MODAL_LAYER,
                  payload: content
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};

var popModalLayer = function popModalLayer() {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(dispatch) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", dispatch({
                  type: POP_MODAL_LAYER
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
};

var initialState = {
  shown: false,
  contentLayers: [{}]
};

var modal = function modal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case TOGGLE_MODAL:
      {
        return _objectSpread2({}, state, {
          contentLayers: [payload || {}],
          shown: !state.shown
        });
      }

    case UPDATE_MODAL_LAYER_CONTENT:
      {
        var currentContentLayer = _objectSpread2({}, state.contentLayers[0], {}, payload);

        return _objectSpread2({}, state, {
          contentLayers: [currentContentLayer].concat(_toConsumableArray(state.contentLayers.slice(1)))
        });
      }

    case PUSH_MODAL_LAYER:
      {
        return _objectSpread2({}, state, {
          contentLayers: [payload].concat(_toConsumableArray(state.contentLayers))
        });
      }

    case POP_MODAL_LAYER:
      {
        return _objectSpread2({}, state, {
          contentLayers: state.contentLayers.slice(1)
        });
      }

    default:
      return state;
  }
};

var cargoReducer = combineReducers({
  modal: modal
});

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".Card_Card__os9oI {\n  border: 1px solid #e3eaef;\n  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);\n  padding: 1.5rem;\n  background: #fff;\n  border-radius: 4px; }\n";
var css$1 = {
  "Card": "Card_Card__os9oI"
};
styleInject(css);

var Card = function Card(_ref) {
  var center = _ref.center,
      textCenter = _ref.textCenter,
      children = _ref.children,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ["center", "textCenter", "children", "style"]);

  var additionalClasses = [css$1.Card, center ? 'center mt-3 col-xs-12' : '', textCenter ? 'text-center' : ''].filter(Boolean);
  return React.createElement("div", _extends({
    className: additionalClasses.join(' '),
    style: style
  }, props), children);
};
/*!
 * Font Awesome Free 5.15.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */


function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1();
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$1(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;

var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');
var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';

var PRODUCTION = function () {
  try {
    return process.env.NODE_ENV === 'production';
  } catch (e) {
    return false;
  }
}();

var DUOTONE_CLASSES = {
  GROUP: 'group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  // For example <script data-search-pseudo-elements src="..."></script>
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray$1(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

var _config = _objectSpread({}, _default, initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;

var config = _objectSpread({}, _config);

WINDOW.FontAwesomeConfig = config;
var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];
var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

var isNode = typeof global !== 'undefined' && typeof global.process !== 'undefined' && typeof global.process.emit === 'function';
var asyncSetTimer = typeof setImmediate === 'undefined' ? setTimeout : setImmediate;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};

function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}

var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}

function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}

function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
  }, '');
}

function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}

function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }

  return abstract;
}

function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}

function makeIconMasking(_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      mask = _ref.mask,
      explicitMaskId = _ref.maskId,
      transform = _ref.transform;
  var mainWidth = main.width,
      mainPath = main.icon;
  var maskWidth = mask.width,
      maskPath = mask.icon;
  var trans = transformForSvg({
    transform: transform,
    containerWidth: maskWidth,
    iconWidth: mainWidth
  });
  var maskRect = {
    tag: 'rect',
    attributes: _objectSpread({}, ALL_SPACE, {
      fill: 'white'
    })
  };
  var maskInnerGroupChildrenMixin = mainPath.children ? {
    children: mainPath.children.map(fillBlack)
  } : {};
  var maskInnerGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.inner),
    children: [fillBlack(_objectSpread({
      tag: mainPath.tag,
      attributes: _objectSpread({}, mainPath.attributes, trans.path)
    }, maskInnerGroupChildrenMixin))]
  };
  var maskOuterGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.outer),
    children: [maskInnerGroup]
  };
  var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
  var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
  var maskTag = {
    tag: 'mask',
    attributes: _objectSpread({}, ALL_SPACE, {
      id: maskId,
      maskUnits: 'userSpaceOnUse',
      maskContentUnits: 'userSpaceOnUse'
    }),
    children: [maskRect, maskOuterGroup]
  };
  var defs = {
    tag: 'defs',
    children: [{
      tag: 'clipPath',
      attributes: {
        id: clipId
      },
      children: deGroup(maskPath)
    }, maskTag]
  };
  children.push(defs, {
    tag: 'rect',
    attributes: _objectSpread({
      fill: 'currentColor',
      'clip-path': "url(#".concat(clipId, ")"),
      mask: "url(#".concat(maskId, ")")
    }, ALL_SPACE)
  });
  return {
    children: children,
    attributes: attributes
  };
}

function makeIconStandard(_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      transform = _ref.transform,
      styles = _ref.styles;
  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  if (transformIsMeaningful(transform)) {
    var trans = transformForSvg({
      transform: transform,
      containerWidth: main.width,
      iconWidth: main.width
    });
    children.push({
      tag: 'g',
      attributes: _objectSpread({}, trans.outer),
      children: [{
        tag: 'g',
        attributes: _objectSpread({}, trans.inner),
        children: [{
          tag: main.icon.tag,
          children: main.icon.children,
          attributes: _objectSpread({}, main.icon.attributes, trans.path)
        }]
      }]
    });
  } else {
    children.push(main.icon);
  }

  return {
    children: children,
    attributes: attributes
  };
}

function asIcon(_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread({}, styles, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol(_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread({}, attributes, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var widthClass = isUploadedIcon ? '' : "fa-w-".concat(Math.ceil(width / height * 16));
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : '', widthClass].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread({}, extra.attributes, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) content.children.push({
    tag: 'title',
    attributes: {
      id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
    },
    children: [title]
  });

  var args = _objectSpread({}, content, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread({}, uploadedIconWidthStyle, extra.styles)
  });

  var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalized);
  } else {
    namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var styles = namespace.styles,
    shims = namespace.shims;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};

var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    var ligatures = icon[2];
    acc[iconName] = iconName;
    ligatures.forEach(function (ligature) {
      acc[ligature] = iconName;
    });
    return acc;
  });
  var hasRegular = 'far' in styles;
  _byOldName = reduce(shims, function (acc, shim) {
    var oldName = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    acc[oldName] = {
      prefix: prefix,
      iconName: iconName
    };
    return acc;
  }, {});
};

build();
var styles$1 = namespace.styles;

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };

  if (!transformString) {
    return transform;
  } else {
    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
      var parts = n.toLowerCase().split('-');
      var first = parts[0];
      var rest = parts.slice(1).join('-');

      if (first && rest === 'h') {
        acc.flipX = true;
        return acc;
      }

      if (first && rest === 'v') {
        acc.flipY = true;
        return acc;
      }

      rest = parseFloat(rest);

      if (isNaN(rest)) {
        return acc;
      }

      switch (first) {
        case 'grow':
          acc.size = acc.size + rest;
          break;

        case 'shrink':
          acc.size = acc.size - rest;
          break;

        case 'left':
          acc.x = acc.x - rest;
          break;

        case 'right':
          acc.x = acc.x + rest;
          break;

        case 'up':
          acc.y = acc.y - rest;
          break;

        case 'down':
          acc.y = acc.y + rest;
          break;

        case 'rotate':
          acc.rotate = acc.rotate + rest;
          break;
      }

      return acc;
    }, transform);
  }
};

function MissingIcon(error) {
  this.name = 'MissingIcon';
  this.message = error || 'Icon unavailable';
  this.stack = new Error().stack;
}

MissingIcon.prototype = Object.create(Error.prototype);
MissingIcon.prototype.constructor = MissingIcon;
var FILL = {
  fill: 'currentColor'
};
var ANIMATION_BASE = {
  attributeType: 'XML',
  repeatCount: 'indefinite',
  dur: '2s'
};
var RING = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
  })
};

var OPACITY_ANIMATE = _objectSpread({}, ANIMATION_BASE, {
  attributeName: 'opacity'
});

var DOT = {
  tag: 'circle',
  attributes: _objectSpread({}, FILL, {
    cx: '256',
    cy: '364',
    r: '28'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, ANIMATION_BASE, {
      attributeName: 'r',
      values: '28;14;28;28;14;28;'
    })
  }, {
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;1;1;0;1;'
    })
  }]
};
var QUESTION = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '1',
    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;0;0;0;1;'
    })
  }]
};
var EXCLAMATION = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '0',
    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '0;0;1;1;0;0;'
    })
  }]
};
var styles$2 = namespace.styles;

function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray$1(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}

var styles$3 = namespace.styles;
var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}";

function css$2() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var Library =
/*#__PURE__*/
function () {
  function Library() {
    _classCallCheck$1(this, Library);

    this.definitions = {};
  }

  _createClass$1(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread({}, _this.definitions[key] || {}, additions[key]);
        defineIcons(key, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        if (!additions[prefix]) additions[prefix] = {};
        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css$2());
    _cssInserted = true;
  }
}

function apiObject(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function findIconDefinition(iconLookup) {
  var _iconLookup$prefix = iconLookup.prefix,
      prefix = _iconLookup$prefix === void 0 ? 'fa' : _iconLookup$prefix,
      iconName = iconLookup.iconName;
  if (!iconName) return;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread({}, params, {
      mask: mask
    }));
  };
}

var library = new Library();
var _cssInserted = false;
var parse = {
  transform: function transform(transformString) {
    return parseTransformString(transformString);
  }
};
var icon = resolveIcons(function (iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return apiObject(_objectSpread({
    type: 'icon'
  }, iconDefinition), function () {
    ensureCss();

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread({}, meaninglessTransform, transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
});

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _nonIterableSpread$1();
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray$1(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
} // Get CSS class list from a props object


function classList(props) {
  var _classes;

  var spin = props.spin,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-spin': spin,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, _defineProperty$2(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty$2(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty$2(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty$2(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
} // Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number


function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties$1(extraProps, ["style"]);

  mixins.attrs['style'] = _objectSpread2$1({}, mixins.attrs['style'], {}, existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, _objectSpread2$1({}, mixins.attrs, {}, remaining)].concat(_toConsumableArray$1(children)));
}

var PRODUCTION$1 = false;

try {
  PRODUCTION$1 = process.env.NODE_ENV === 'production';
} catch (e) {}

function log() {
  if (!PRODUCTION$1 && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
} // Normalize icon arguments


function normalizeIconArgs(icon) {
  // if the icon is null, there's nothing to do
  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (_typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two


  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
} // creates an object with a key of key
// and a value of value
// if certain conditions are met


function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty$2({}, key, value) : {};
}

function FontAwesomeIcon(_ref) {
  var forwardedRef = _ref.forwardedRef,
      props = _objectWithoutProperties$1(_ref, ["forwardedRef"]);

  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className,
      title = props.title;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(_toConsumableArray$1(classList(props)), _toConsumableArray$1(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? parse.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = icon(iconLookup, _objectSpread2$1({}, classes, {}, transform, {}, mask, {
    symbol: symbol,
    title: title
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: forwardedRef
  };
  Object.keys(props).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
}

FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  border: PropTypes.bool,
  className: PropTypes.string,
  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  flip: PropTypes.oneOf(['horizontal', 'vertical', 'both']),
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  listItem: PropTypes.bool,
  pull: PropTypes.oneOf(['right', 'left']),
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([0, 90, 180, 270]),
  size: PropTypes.oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: PropTypes.bool,
  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string,
  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  swapOpacity: PropTypes.bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  fixedWidth: false,
  inverse: false,
  flip: null,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  symbol: false,
  title: '',
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, React.createElement);

var CollapsibleCard =
/*#__PURE__*/
function (_Component) {
  _inherits(CollapsibleCard, _Component);

  function CollapsibleCard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CollapsibleCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CollapsibleCard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      collapsed: _this.props.collapsed
    });

    _defineProperty(_assertThisInitialized(_this), "toggleCollapse", function () {
      if (_this.props.onClick && _this.state.collapsed) _this.props.onClick();

      _this.setState({
        collapsed: !_this.state.collapsed
      });
    });

    return _this;
  }

  _createClass(CollapsibleCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          collapsedContent = _this$props.collapsedContent,
          title = _this$props.title,
          isCollapsed = _this$props.collapsed,
          onClick = _this$props.onClick,
          props = _objectWithoutProperties(_this$props, ["children", "collapsedContent", "title", "collapsed", "onClick"]);

      var collapsed = this.state.collapsed;
      return React.createElement(Card, props, React.createElement("div", {
        onClick: this.toggleCollapse,
        style: {
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, title, React.createElement(FontAwesomeIcon, {
        icon: collapsed ? 'angle-down' : 'angle-up'
      })), collapsed ? collapsedContent : children);
    }
  }]);

  return CollapsibleCard;
}(Component);

var css$3 = ".Table_Table__1YoVd {\n  border: 1px solid rgba(208, 208, 208, 0.3);\n  overflow: hidden; }\n  .Table_Table__1YoVd .Table_TableHeader__5YkYR, .Table_Table__1YoVd .Table_TableBody__1B-aB > .Table_TableRow__2n-c4 {\n    display: flex;\n    justify-content: space-between; }\n    .Table_Table__1YoVd .Table_TableHeader__5YkYR > div:first-of-type, .Table_Table__1YoVd .Table_TableBody__1B-aB > .Table_TableRow__2n-c4 > div:first-of-type {\n      text-align: left; }\n      .Table_Table__1YoVd .Table_TableHeader__5YkYR > div:first-of-type:hover, .Table_Table__1YoVd .Table_TableBody__1B-aB > .Table_TableRow__2n-c4 > div:first-of-type:hover {\n        background: #dee0ff; }\n    .Table_Table__1YoVd .Table_TableHeader__5YkYR > div:last-of-type, .Table_Table__1YoVd .Table_TableBody__1B-aB > .Table_TableRow__2n-c4 > div:last-of-type {\n      text-align: right; }\n      .Table_Table__1YoVd .Table_TableHeader__5YkYR > div:last-of-type:hover, .Table_Table__1YoVd .Table_TableBody__1B-aB > .Table_TableRow__2n-c4 > div:last-of-type:hover {\n        background: #dee0ff; }\n    .Table_Table__1YoVd .Table_TableHeader__5YkYR > div, .Table_Table__1YoVd .Table_TableBody__1B-aB > .Table_TableRow__2n-c4 > div {\n      display: inline-block;\n      text-align: center; }\n      .Table_Table__1YoVd .Table_TableHeader__5YkYR > div:hover, .Table_Table__1YoVd .Table_TableBody__1B-aB > .Table_TableRow__2n-c4 > div:hover {\n        background: #dee0ff; }\n  .Table_Table__1YoVd .Table_TableHeader__5YkYR {\n    border-bottom: 1px solid rgba(208, 208, 208, 0.3);\n    user-select: none;\n    font-size: 10px; }\n    .Table_Table__1YoVd .Table_TableHeader__5YkYR > div:first-of-type {\n      border-right: 1px solid rgba(208, 208, 208, 0.3); }\n    .Table_Table__1YoVd .Table_TableHeader__5YkYR > div:not(:last-of-type) {\n      border-right: 1px solid rgba(208, 208, 208, 0.3); }\n    .Table_Table__1YoVd .Table_TableHeader__5YkYR div {\n      padding: 10px 15px;\n      color: #848484; }\n      .Table_Table__1YoVd .Table_TableHeader__5YkYR div .Table_TableSortArrow__1Cw2b {\n        display: inline-block;\n        margin-left: 5px; }\n  .Table_Table__1YoVd .Table_TableBody__1B-aB {\n    overflow-y: auto; }\n    .Table_Table__1YoVd .Table_TableBody__1B-aB .Table_TableRow__2n-c4 {\n      padding: 10px 15px;\n      align-items: center;\n      border: none;\n      font-size: 12px; }\n      .Table_Table__1YoVd .Table_TableBody__1B-aB .Table_TableRow__2n-c4:hover, .Table_Table__1YoVd .Table_TableBody__1B-aB .Table_TableRow__2n-c4[data-selected=\"true\"] {\n        background: #dee0ff;\n        border-style: none; }\n      .Table_Table__1YoVd .Table_TableBody__1B-aB .Table_TableRow__2n-c4 button {\n        background: #7B7AED;\n        color: #fff;\n        border-radius: 4px;\n        font-weight: bold;\n        padding: 8px 12px;\n        font-size: 10px; }\n    .Table_Table__1YoVd .Table_TableBody__1B-aB .Table_Empty__1Aqz1 {\n      text-align: center;\n      padding: 40px 15px; }\n  .Table_Table__1YoVd .Table_TablePagination__3i4-n {\n    text-align: center;\n    border-top: 1px solid #dadada;\n    padding-top: 2px;\n    position: relative; }\n    .Table_Table__1YoVd .Table_TablePagination__3i4-n .Table_PageCount__1Hzl3 {\n      display: inline-block;\n      margin: 0 10px; }\n    .Table_Table__1YoVd .Table_TablePagination__3i4-n button {\n      border: none;\n      background: transparent;\n      margin: 0 5px;\n      cursor: pointer; }\n";
var css$4 = {
  "Table": "Table_Table__1YoVd",
  "TableHeader": "Table_TableHeader__5YkYR",
  "TableBody": "Table_TableBody__1B-aB",
  "TableRow": "Table_TableRow__2n-c4",
  "TableSortArrow": "Table_TableSortArrow__1Cw2b",
  "Empty": "Table_Empty__1Aqz1",
  "TablePagination": "Table_TablePagination__3i4-n",
  "PageCount": "Table_PageCount__1Hzl3"
};
styleInject(css$3);

var Table = function Table(_ref) {
  var data = _ref.data,
      mapping = _ref.mapping,
      emptyText = _ref.emptyText,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      onRowSelect = _ref.onRowSelect,
      selected = _ref.selected,
      growWithContainer = _ref.growWithContainer,
      bindForcePageChange = _ref.bindForcePageChange,
      _ref$pagination = _ref.pagination,
      pagination = _ref$pagination === void 0 ? {} : _ref$pagination;

  var paginationSettings = _objectSpread2({
    defaultPageSize: 25,
    pageSizes: [25, 50, 100],
    usePagination: !!Object.keys(pagination).length,
    totalRecords: 0,
    reloadData: function reloadData(pageNum, pageSize) {}
  }, pagination);

  var _useState = useState('auto'),
      _useState2 = _slicedToArray(_useState, 2),
      maxColWidth = _useState2[0],
      setMaxColWidth = _useState2[1];

  var _useState3 = useState('auto'),
      _useState4 = _slicedToArray(_useState3, 2),
      maxBodyHeight = _useState4[0],
      setMaxBodyHeight = _useState4[1];

  var _useState5 = useState(1),
      _useState6 = _slicedToArray(_useState5, 2),
      currentPage = _useState6[0],
      setCurrentPage = _useState6[1];

  var _useState7 = useState(paginationSettings.defaultPageSize),
      _useState8 = _slicedToArray(_useState7, 2),
      pageSize = _useState8[0],
      setPageSize = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      _useState10$ = _slicedToArray(_useState10[0], 3),
      currentSortCol = _useState10$[0],
      currentSortComparator = _useState10$[1],
      currentSortDir = _useState10$[2],
      setSortFilter = _useState10[1];

  if (bindForcePageChange) bindForcePageChange(setCurrentPage);

  var tableStyle = _objectSpread2({}, style);

  if (growWithContainer) tableStyle.height = '100%';

  var _setSelectedRow = function _setSelectedRow(row) {
    return onRowSelect && onRowSelect(row);
  };

  var calculateMaxColWidth = useCallback(function (node) {
    if (node !== null) {
      var ro = new ResizeObserver(function (e) {
        if (growWithContainer) {
          setMaxBodyHeight(node.getBoundingClientRect().height - (paginationSettings.usePagination ? 72 : 30));
        }

        setMaxColWidth((node.getBoundingClientRect().width - 30) / mapping.length);
      });
      ro.observe(node);
    }
  }, []);

  var loadPage = function loadPage(pageNum) {
    return function () {
      setCurrentPage(pageNum);
      paginationSettings.reloadData(pageNum, pageSize);
    };
  };

  var setPageSizeAndReload = function setPageSizeAndReload(_ref2) {
    var value = _ref2.target.value;
    var pageSize = parseInt(value);
    setCurrentPage(1);
    setPageSize(pageSize);
    paginationSettings.reloadData(1, pageSize);
  };

  var toggleSort = function toggleSort(column, comparator) {
    return function () {
      if (!comparator) return function () {};

      if (currentSortCol === column && currentSortDir === 'ASC') {
        return setSortFilter([column, comparator, 'DESC']);
      }

      return setSortFilter([column, comparator, 'ASC']);
    };
  };

  var sortedData = _toConsumableArray(data);

  if (currentSortCol) {
    sortedData = sortedData.sort(currentSortComparator);
    if (currentSortDir === 'DESC') sortedData.reverse();
  }

  var totalPages = Math.ceil(paginationSettings.totalRecords / pageSize);
  return React.createElement("div", {
    className: css$4.Table,
    style: tableStyle,
    ref: calculateMaxColWidth
  }, React.createElement("div", {
    className: css$4.TableHeader
  }, mapping.map(function (_ref3, i) {
    var column = _ref3.column,
        comparator = _ref3.comparator;
    return React.createElement("div", {
      onClick: toggleSort(column, comparator),
      key: column + i,
      style: {
        width: maxColWidth,
        cursor: comparator ? 'pointer' : null
      }
    }, column, comparator && (currentSortCol === column ? currentSortDir === 'ASC' ? React.createElement("span", {
      className: css$4.TableSortArrow
    }, "\u2193") : React.createElement("span", {
      className: css$4.TableSortArrow,
      style: {
        transform: 'rotate(180deg)'
      }
    }, "\u2193") : React.createElement("span", {
      className: css$4.TableSortArrow
    }, "\u2195")));
  })), React.createElement("div", {
    className: css$4.TableBody,
    style: {
      height: maxBodyHeight
    }
  }, sortedData.length === 0 && React.createElement("div", {
    className: css$4.Empty
  }, emptyText || 'No data.'), sortedData.map(function (row, i) {
    return React.createElement("div", {
      className: css$4.TableRow,
      key: 'row-' + Object.keys(row).join('') + i,
      style: onRowSelect ? {
        cursor: 'pointer'
      } : {},
      onClick: function onClick() {
        return _setSelectedRow(row);
      },
      "data-selected": row.id === selected
    }, mapping.map(function (_ref4, j) {
      var content = _ref4.content;
      return React.createElement("div", {
        key: 'col-' + Object.keys(row).join('') + i + j,
        style: {
          width: maxColWidth
        }
      }, content(row));
    }));
  })), paginationSettings.usePagination && React.createElement("div", {
    className: css$4.TablePagination
  }, React.createElement("div", {
    style: {
      position: 'absolute',
      left: 5
    }
  }, paginationSettings.totalRecords > 0 ? React.createElement("span", null, "Showing ", pageSize * (currentPage - 1) + 1, " - ", Math.min(pageSize * currentPage + 1, paginationSettings.totalRecords), " of ", paginationSettings.totalRecords) : 'Showing 0 records'), React.createElement("button", {
    onClick: loadPage(1),
    disabled: currentPage === 1
  }, React.createElement(FontAwesomeIcon, {
    icon: "angle-double-left"
  })), React.createElement("button", {
    onClick: loadPage(currentPage - 1),
    disabled: currentPage === 1
  }, React.createElement(FontAwesomeIcon, {
    icon: "angle-left"
  })), React.createElement("p", {
    className: css$4.PageCount
  }, "Page ", currentPage, " of ", Math.max(1, totalPages)), React.createElement("button", {
    onClick: loadPage(currentPage + 1),
    disabled: currentPage >= totalPages
  }, React.createElement(FontAwesomeIcon, {
    icon: "angle-right"
  })), React.createElement("button", {
    onClick: loadPage(totalPages),
    disabled: currentPage >= totalPages
  }, React.createElement(FontAwesomeIcon, {
    icon: "angle-double-right"
  })), React.createElement("select", {
    style: {
      position: 'absolute',
      right: 5
    },
    onChange: setPageSizeAndReload
  }, paginationSettings.pageSizes.map(function (size) {
    return React.createElement("option", {
      value: size,
      selected: size === pageSize
    }, size, " items per page");
  }))));
};

Table.propTypes = {
  data: PropTypes.array.isRequired,
  mapping: PropTypes.array.isRequired,
  emptyText: PropTypes.string,
  style: PropTypes.object
};

var RecursiveElement =
/*#__PURE__*/
function (_Component) {
  _inherits(RecursiveElement, _Component);

  function RecursiveElement() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RecursiveElement);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RecursiveElement)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      tag: React.Fragment
    });

    _defineProperty(_assertThisInitialized(_this), "getTag",
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(fetchAsset, nodeType, data, marks) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(nodeType === 'paragraph')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", function (_ref2) {
                  var children = _ref2.children;
                  return React.createElement("p", null, children);
                });

              case 2:
                if (!(nodeType === 'heading-1')) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", function (_ref3) {
                  var children = _ref3.children;
                  return React.createElement("h1", null, children);
                });

              case 4:
                if (!(nodeType === 'heading-2')) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", function (_ref4) {
                  var children = _ref4.children;
                  return React.createElement("h2", null, children);
                });

              case 6:
                if (!(nodeType === 'heading-3')) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", function (_ref5) {
                  var children = _ref5.children;
                  return React.createElement("h3", null, children);
                });

              case 8:
                if (!(nodeType === 'heading-4')) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", function (_ref6) {
                  var children = _ref6.children;
                  return React.createElement("h4", null, children);
                });

              case 10:
                if (!(nodeType === 'heading-5')) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", function (_ref7) {
                  var children = _ref7.children;
                  return React.createElement("h5", null, children);
                });

              case 12:
                if (!(nodeType === 'heading-6')) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return", function (_ref8) {
                  var children = _ref8.children;
                  return React.createElement("h6", null, children);
                });

              case 14:
                if (!(nodeType === 'ordered-list')) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt("return", function (_ref9) {
                  var children = _ref9.children;
                  return React.createElement("ol", null, children);
                });

              case 16:
                if (!(nodeType === 'unordered-list')) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("return", function (_ref10) {
                  var children = _ref10.children;
                  return React.createElement("ul", null, children);
                });

              case 18:
                if (!(nodeType === 'list-item')) {
                  _context.next = 20;
                  break;
                }

                return _context.abrupt("return", function (_ref11) {
                  var children = _ref11.children;
                  return React.createElement("li", null, children);
                });

              case 20:
                if (!(nodeType === 'hyperlink')) {
                  _context.next = 22;
                  break;
                }

                return _context.abrupt("return", function (_ref12) {
                  var children = _ref12.children;
                  return React.createElement("a", {
                    href: data.uri
                  }, children);
                });

              case 22:
                if (!(nodeType === 'blockquote')) {
                  _context.next = 24;
                  break;
                }

                return _context.abrupt("return", function (_ref13) {
                  var children = _ref13.children;
                  return React.createElement("blockquote", null, children);
                });

              case 24:
                if (!(nodeType === 'text')) {
                  _context.next = 26;
                  break;
                }

                return _context.abrupt("return", _this.generateText(marks));

              case 26:
                if (!(nodeType === 'embedded-asset-block')) {
                  _context.next = 30;
                  break;
                }

                _context.next = 29;
                return _this.generateEmbeddedAsset(fetchAsset, data);

              case 29:
                return _context.abrupt("return", _context.sent);

              case 30:
                return _context.abrupt("return", function (_ref14) {
                  var children = _ref14.children;
                  return React.createElement("div", null, children);
                });

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "generateText", function () {
      var marks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return function (_ref15) {
        var children = _ref15.children;
        var style = marks.reduce(function (acc, _ref16) {
          var type = _ref16.type;
          if (type === 'bold') return _objectSpread2({}, acc, {
            fontWeight: 'bold'
          });
          if (type === 'underline') return _objectSpread2({}, acc, {
            textDecoration: 'underline'
          });
          if (type === 'italic') return _objectSpread2({}, acc, {
            fontStyle: 'italic'
          });
          return acc;
        }, {});
        return React.createElement("span", {
          style: style
        }, children);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "generateEmbeddedAsset",
    /*#__PURE__*/
    function () {
      var _ref17 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(fetchAsset, data) {
        var fileUrl;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetchAsset(data.target.sys.id);

              case 2:
                fileUrl = _context2.sent;
                return _context2.abrupt("return", function () {
                  return React.createElement("img", {
                    src: 'https:' + fileUrl
                  });
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x5, _x6) {
        return _ref17.apply(this, arguments);
      };
    }());

    return _this;
  }

  _createClass(RecursiveElement, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this$props, fetchAsset, _this$props$nodeInfo, data, marks, nodeType;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props = this.props, fetchAsset = _this$props.fetchAsset, _this$props$nodeInfo = _this$props.nodeInfo, data = _this$props$nodeInfo.data, marks = _this$props$nodeInfo.marks, nodeType = _this$props$nodeInfo.nodeType;
                _context3.t0 = this;
                _context3.next = 4;
                return this.getTag(fetchAsset, nodeType, data, marks);

              case 4:
                _context3.t1 = _context3.sent;
                _context3.t2 = {
                  tag: _context3.t1
                };

                _context3.t0.setState.call(_context3.t0, _context3.t2);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          fetchAsset = _this$props2.fetchAsset,
          _this$props2$nodeInfo = _this$props2.nodeInfo,
          _this$props2$nodeInfo2 = _this$props2$nodeInfo.content,
          content = _this$props2$nodeInfo2 === void 0 ? [] : _this$props2$nodeInfo2,
          value = _this$props2$nodeInfo.value;
      var Tag = this.state.tag;
      return React.createElement(Tag, null, content.map(function (nodeInfo, i) {
        return React.createElement(RecursiveElement, {
          key: i,
          nodeInfo: nodeInfo,
          fetchAsset: fetchAsset
        });
      }), value);
    }
  }]);

  return RecursiveElement;
}(Component);

var API_BASE_URL = 'https://cdn.contentful.com';
var ACCESS_TOKEN = 'qap2-xpW4EQkhuu2Fc0zPF9uiGNXMFGsDW7FrcS3jN0'; // TODO: Decide if we're going to really implement environments: https://www.contentful.com/developers/docs/concepts/multiple-environments/

var ENVIRONMENT = 'master'; // process.env.REACT_APP_APP_ENV === 'prod' ? 'master' : 'staging'

var Documentation =
/*#__PURE__*/
function (_Component) {
  _inherits(Documentation, _Component);

  function Documentation() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Documentation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Documentation)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      documentationBody: null,
      client: null,
      error: false
    });

    _defineProperty(_assertThisInitialized(_this), "fetchAsset",
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(assetId) {
        var _this$props$spaceId, spaceId, url, resp, asset;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props$spaceId = _this.props.spaceId, spaceId = _this$props$spaceId === void 0 ? 'hjoc0nu0k525' : _this$props$spaceId;
                url = "".concat(API_BASE_URL, "/spaces/").concat(spaceId, "/environments/").concat(ENVIRONMENT, "/assets/").concat(assetId, "?access_token=").concat(ACCESS_TOKEN);
                _context.next = 4;
                return fetch(url, {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                });

              case 4:
                resp = _context.sent;

                if (!(resp.status !== 200)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", _this.setState({
                  error: true
                }));

              case 7:
                _context.next = 9;
                return resp.json();

              case 9:
                asset = _context.sent;
                return _context.abrupt("return", asset.fields.file.url);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    return _this;
  }

  _createClass(Documentation, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this$props, _this$props$spaceId2, spaceId, _this$props$bodyKey, bodyKey, entryId, url, resp, _ref2, fields;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = this.props, _this$props$spaceId2 = _this$props.spaceId, spaceId = _this$props$spaceId2 === void 0 ? 'hjoc0nu0k525' : _this$props$spaceId2, _this$props$bodyKey = _this$props.bodyKey, bodyKey = _this$props$bodyKey === void 0 ? 'helpBody' : _this$props$bodyKey, entryId = _this$props.entryId;
                url = "".concat(API_BASE_URL, "/spaces/").concat(spaceId, "/environments/").concat(ENVIRONMENT, "/entries/").concat(entryId, "?access_token=").concat(ACCESS_TOKEN);
                _context2.next = 4;
                return fetch(url, {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                });

              case 4:
                resp = _context2.sent;

                if (!(resp.status !== 200)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", this.setState({
                  error: true
                }));

              case 7:
                _context2.next = 9;
                return resp.json();

              case 9:
                _ref2 = _context2.sent;
                fields = _ref2.fields;
                this.setState({
                  documentationBody: fields[bodyKey]
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          documentationBody = _this$state.documentationBody,
          client = _this$state.client,
          error = _this$state.error;
      if (error) return "Error loading documentation.";
      if (!documentationBody) return "Loading documentation...";
      return React.createElement(RecursiveElement, {
        nodeInfo: documentationBody,
        fetchAsset: this.fetchAsset
      });
    }
  }]);

  return Documentation;
}(Component);

_defineProperty(Documentation, "propTypes", {
  entryId: PropTypes.string.isRequired,
  spaceId: PropTypes.string,
  bodyKey: PropTypes.string
});

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var shadeBlendColor = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * This will take a HEX or RGB web color. pSBC can shade it darker or lighter,
   * or blend it with a second color, and can also pass it right thru but convert
   * from Hex to RGB (Hex2RGB) or RGB to Hex (RGB2Hex).
   * All without you even knowing what color format you are using.
   *
   * @param {number} p - From 0 to 1 Percentage float (Required).
   * @param {string} from - From 0 to 1 Percentage float (Required).
   * @param {string} to - From 0 to 1 Percentage float (Required).
   * @returns {string|null} Either Hex or RGB color. Null if invalid color or percentage number.
   */

  exports.default = function (p, from, to) {
    if (typeof p !== "number" || p < -1 || p > 1 || typeof from !== "string" || from[0] != "r" && from[0] != "#" || to && typeof to !== "string") return null; // ErrorCheck

    var sbcRip = function sbcRip(d) {
      var l = d.length;
      var RGB = {};

      if (l > 9) {
        d = d.split(",");
        if (d.length < 3 || d.length > 4) return null; // ErrorCheck

        RGB[0] = i(d[0].split("(")[1]), RGB[1] = i(d[1]), RGB[2] = i(d[2]), RGB[3] = d[3] ? parseFloat(d[3]) : -1;
      } else {
        if (l == 8 || l == 6 || l < 4) return null; // ErrorCheck

        if (l < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (l > 4 ? "" + d[4] + d[4] : ""); // 3 or 4 digit

        d = i(d.slice(1), 16), RGB[0] = d >> 16 & 255, RGB[1] = d >> 8 & 255, RGB[2] = d & 255, RGB[3] = -1;
        if (l == 9 || l == 5) RGB[3] = r(RGB[2] / 255 * 10000) / 10000, RGB[2] = RGB[1], RGB[1] = RGB[0], RGB[0] = d >> 24 & 255;
      }

      return RGB;
    };

    var i = parseInt;
    var r = Math.round;
    var h = from.length > 9;
    var h = typeof to === "string" ? to.length > 9 ? true : to == "c" ? !h : false : h;
    var b = p < 0;
    var p = b ? p * -1 : p;
    var to = to && to != "c" ? to : b ? "#000000" : "#FFFFFF";
    var f = sbcRip(from);
    var t = sbcRip(to);
    if (!f || !t) return null; // ErrorCheck

    if (h) return "rgb" + (f[3] > -1 || t[3] > -1 ? "a(" : "(") + r((t[0] - f[0]) * p + f[0]) + "," + r((t[1] - f[1]) * p + f[1]) + "," + r((t[2] - f[2]) * p + f[2]) + (f[3] < 0 && t[3] < 0 ? ")" : "," + (f[3] > -1 && t[3] > -1 ? r(((t[3] - f[3]) * p + f[3]) * 10000) / 10000 : t[3] < 0 ? f[3] : t[3]) + ")");
    return "#" + (0x100000000 + r((t[0] - f[0]) * p + f[0]) * 0x1000000 + r((t[1] - f[1]) * p + f[1]) * 0x10000 + r((t[2] - f[2]) * p + f[2]) * 0x100 + (f[3] > -1 && t[3] > -1 ? r(((t[3] - f[3]) * p + f[3]) * 255) : t[3] > -1 ? r(t[3] * 255) : f[3] > -1 ? r(f[3] * 255) : 255)).toString(16).slice(1, f[3] > -1 || t[3] > -1 ? undefined : -2);
  };
});
unwrapExports(shadeBlendColor);
var CargoContext = createContext({
  primaryColor: '#F95C00',
  secondaryColor: '#61B7D5'
});
var css$5 = ".Button_TextDiv__24plo {\n  text-transform: uppercase;\n  position: relative;\n  z-index: 1; }\n\n.Button_Button__2pL_i {\n  padding: 8px 12px;\n  position: relative;\n  font-weight: 500;\n  font-family: \"Beatrice Bold\", helvetica, arial;\n  font-size: 10px;\n  border: 1px solid #5b66ff;\n  cursor: pointer;\n  overflow-x: hidden;\n  text-transform: uppercase;\n  transition: all 0.5s cubic-bezier(0.64, 0.04, 0.35, 1); }\n  .Button_Button__2pL_i .Button_TextDiv__24plo {\n    transition: all 0.5s cubic-bezier(0.64, 0.04, 0.35, 1); }\n  .Button_Button__2pL_i.Button_Secondary__3PZwA:not([disabled])::before {\n    transform: scaleY(0);\n    z-index: 0;\n    width: 101%;\n    position: absolute;\n    content: '';\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: #5b66ff;\n    transform-origin: 50% 100%;\n    transition: all 0.5s cubic-bezier(0.64, 0.04, 0.35, 1); }\n  .Button_Button__2pL_i:focus {\n    outline: none; }\n  .Button_Button__2pL_i.Button_Secondary__3PZwA:not([disabled]):hover::before {\n    transform: scaleY(1); }\n  .Button_Button__2pL_i.Button_Secondary__3PZwA:not([disabled]):hover .Button_TextDiv__24plo {\n    color: #fff; }\n  .Button_Button__2pL_i.Button_Primary__uCToB:hover {\n    opacity: 0.9; }\n";
var css$6 = {
  "TextDiv": "Button_TextDiv__24plo",
  "Button": "Button_Button__2pL_i",
  "Secondary": "Button_Secondary__3PZwA",
  "Primary": "Button_Primary__uCToB"
};
styleInject(css$5);

var Button = function Button(_ref) {
  var text = _ref.text,
      onClick = _ref.onClick,
      bold = _ref.bold,
      primary = _ref.primary,
      secondary = _ref.secondary,
      disabled = _ref.disabled,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#5b66ff' : _ref$color,
      style = _ref.style;

  var _useContext = useContext(CargoContext),
      primaryColor = _useContext.primaryColor;

  var background = '#dadada';
  if (primary) background = primaryColor;
  if (secondary) background = '#fff';

  var styles = _objectSpread2({
    borderColor: '#5b66ff',
    background: background,
    color: color
  }, style);

  if (bold) styles.fontWeight = 'bold';

  if (disabled) {
    styles.opacity = 0.9;
    styles.cursor = 'not-allowed';
    styles.background = '#fff';
    styles.color = '#d0d0d0';
    styles.borderColor = '#d0d0d0';
  }

  return React.createElement("button", {
    style: styles,
    className: [css$6.Button, primary ? css$6.Primary : css$6.Secondary].join(' '),
    onClick: onClick,
    disabled: disabled
  }, React.createElement("div", {
    className: css$6.TextDiv
  }, text));
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  bold: PropTypes.bool,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  style: PropTypes.object
};

var accessKeyOfNullable = function accessKeyOfNullable(nullableObject, key) {
  var missingValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!key) return function (key) {
    var missing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : missingValue;
    return nullableObject ? nullableObject[key] : missing;
  };
  return nullableObject ? nullableObject[key] : missingValue;
};

var css$7 = ".LayeredModal_Modal__206JR {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  align-items: center;\n  z-index: 1000;\n  top: 0; }\n  .LayeredModal_Modal__206JR .LayeredModal_ModalDimmer__2tXje {\n    background-color: rgba(0, 0, 0, 0.5);\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 1000;\n    top: 0; }\n  .LayeredModal_Modal__206JR .LayeredModal_ModalContainer__60A5_ {\n    z-index: 1001;\n    width: 62%;\n    max-height: 95%;\n    position: absolute; }\n    .LayeredModal_Modal__206JR .LayeredModal_ModalContainer__60A5_ .LayeredModal_ModalDragSurface__1MZkP {\n      width: 100%;\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 20px;\n      user-select: none; }\n    .LayeredModal_Modal__206JR .LayeredModal_ModalContainer__60A5_ .LayeredModal_ModalTitle__2A8vO {\n      display: inline-block;\n      font-size: 14px;\n      font-family: 'UntitledSans Medium', helvetica, arial; }\n    .LayeredModal_Modal__206JR .LayeredModal_ModalContainer__60A5_ .LayeredModal_ModalContent__1xRF9 {\n      padding: 20px 0;\n      max-height: 602px;\n      overflow-y: scroll;\n      display: flex; }\n    .LayeredModal_Modal__206JR .LayeredModal_ModalContainer__60A5_ .LayeredModal_ModalActions__2v1yg {\n      margin-top: 22px;\n      display: flex;\n      justify-content: space-between; }\n\n.LayeredModal_ScrollDisabled__3A5oP {\n  height: 100%;\n  overflow: hidden; }\n";
var css$8 = {
  "Modal": "LayeredModal_Modal__206JR",
  "ModalDimmer": "LayeredModal_ModalDimmer__2tXje",
  "ModalContainer": "LayeredModal_ModalContainer__60A5_",
  "ModalDragSurface": "LayeredModal_ModalDragSurface__1MZkP",
  "ModalTitle": "LayeredModal_ModalTitle__2A8vO",
  "ModalContent": "LayeredModal_ModalContent__1xRF9",
  "ModalActions": "LayeredModal_ModalActions__2v1yg",
  "ScrollDisabled": "LayeredModal_ScrollDisabled__3A5oP"
};
styleInject(css$7); // parent if necessary by specifying an object with a key for each subcomponent

var LayeredModal =
/*#__PURE__*/
function (_Component) {
  _inherits(LayeredModal, _Component);

  function LayeredModal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LayeredModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LayeredModal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dragging: false,
      startX: 0,
      startY: 0,
      top: 0,
      left: 0,
      hasDragged: false
    });

    _defineProperty(_assertThisInitialized(_this), "modalContentRef", null);

    _defineProperty(_assertThisInitialized(_this), "withScrollEnabled", function (func) {
      return function () {
        func();
        document.getElementsByTagName('body')[0].classList.remove(css$8.ScrollDisabled);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      if (_this.props.modal.contentLayers[0].beforeClose) {
        _this.props.modal.contentLayers[0].beforeClose();
      }

      _this.props.toggleModal();
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDrag", function (dragging) {
      return function (_ref) {
        var clientX = _ref.clientX,
            clientY = _ref.clientY;

        if (dragging !== _this.state.dragging) {
          _this.setState({
            dragging: dragging,
            startX: clientX,
            startY: clientY,
            left: _this.modalContentRef.offsetLeft,
            top: _this.modalContentRef.offsetTop,
            hasDragged: true
          });
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "drag", function (_ref2) {
      var clientX = _ref2.clientX,
          clientY = _ref2.clientY;
      var _this$state = _this.state,
          dragging = _this$state.dragging,
          top = _this$state.top,
          left = _this$state.left,
          startX = _this$state.startX,
          startY = _this$state.startY;
      if (!dragging) return;
      var maxLeft = Math.min(left + clientX - startX, window.innerWidth - _this.modalContentRef.offsetWidth);
      var maxTop = Math.min(top + clientY - startY, window.innerHeight - _this.modalContentRef.offsetHeight);

      _this.setState({
        top: Math.max(0, maxTop),
        left: Math.max(0, maxLeft),
        startX: clientX,
        startY: clientY
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (_ref3) {
      var key = _ref3.key;
      if (key === 'Escape') _this.closeModal();
    });

    return _this;
  }

  _createClass(LayeredModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$modal = _this$props.modal,
          shown = _this$props$modal.shown,
          _this$props$modal$con = _slicedToArray(_this$props$modal.contentLayers, 1),
          _this$props$modal$con2 = _this$props$modal$con[0],
          title = _this$props$modal$con2.title,
          body = _this$props$modal$con2.body,
          onCancel = _this$props$modal$con2.onCancel,
          onConfirm = _this$props$modal$con2.onConfirm,
          confirmText = _this$props$modal$con2.confirmText,
          cancelText = _this$props$modal$con2.cancelText,
          confirmButtonDisabled = _this$props$modal$con2.confirmButtonDisabled,
          modalWidth = _this$props$modal$con2.modalWidth,
          styleOverrides = _this$props.styleOverrides;

      var _this$state2 = this.state,
          dragging = _this$state2.dragging,
          top = _this$state2.top,
          left = _this$state2.left,
          hasDragged = _this$state2.hasDragged;
      if (!shown) return null;
      var accessStyles = accessKeyOfNullable(styleOverrides, null, {});
      var RenderBody = body;
      var toRender = body === null ? null : body.props ? RenderBody : React.createElement(RenderBody, null);
      var confirmDisabled = typeof confirmButtonDisabled === 'function' ? confirmButtonDisabled() : confirmButtonDisabled;
      return React.createElement("div", {
        className: css$8.Modal,
        onMouseMove: this.drag,
        onKeyDown: this.handleKeyPress,
        onMouseUp: this.toggleDrag(false),
        ref: function ref(node) {
          return node ? node.focus() : null;
        }
      }, React.createElement("div", {
        className: css$8.ModalDimmer,
        onClick: this.withScrollEnabled(this.closeModal)
      }), React.createElement("div", {
        className: css$8.ModalContainer,
        style: {
          width: modalWidth,
          top: hasDragged ? top : null,
          left: hasDragged ? left : null
        },
        ref: function ref(node) {
          return _this2.modalContentRef = node;
        }
      }, React.createElement(Card, {
        style: accessStyles('Card')
      }, React.createElement("span", {
        className: css$8.ModalDragSurface,
        style: {
          cursor: dragging ? 'grabbing' : 'grab'
        },
        onMouseDown: this.toggleDrag(true)
      }, "\xA0"), React.createElement("p", {
        className: css$8.ModalTitle,
        style: accessStyles('Title')
      }, title), React.createElement("div", {
        className: css$8.ModalContent
      }, toRender), React.createElement("div", {
        className: css$8.ModalActions
      }, onCancel && React.createElement(Button, {
        text: cancelText,
        onClick: this.withScrollEnabled(onCancel),
        style: accessStyles('CancelButton'),
        primary: true,
        color: "#fff"
      }), onConfirm && React.createElement(Button, {
        text: confirmText,
        onClick: this.withScrollEnabled(onConfirm),
        style: accessStyles('ConfirmButton'),
        primary: true,
        disabled: confirmDisabled,
        color: "#fff"
      })))));
    }
  }]);

  return LayeredModal;
}(Component);

var LayeredModal$1 = connect(function (_ref4) {
  var modal = _ref4.cargo.modal;
  return {
    modal: modal
  };
}, {
  toggleModal: toggleModal
})(LayeredModal);
var css$9 = ".SearchableDropdown_SearchableDropdown__37P4d {\n  border: 1px solid #d0d0d0;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  display: inline-block; }\n  .SearchableDropdown_SearchableDropdown__37P4d[data-open=\"true\"] {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n    border-color: #5b66ff;\n    background: transparent; }\n    .SearchableDropdown_SearchableDropdown__37P4d[data-open=\"true\"] .SearchableDropdown_DropdownTriangle__2Si7r > div {\n      transform: rotate(180deg); }\n  .SearchableDropdown_SearchableDropdown__37P4d .SearchableDropdown_DropdownToggle__3DFyP {\n    display: flex;\n    justify-content: space-between; }\n    .SearchableDropdown_SearchableDropdown__37P4d .SearchableDropdown_DropdownToggle__3DFyP .SearchableDropdown_Placeholder__ltKFz {\n      display: inline-flex;\n      padding: 8px 12px;\n      margin: 0; }\n    .SearchableDropdown_SearchableDropdown__37P4d .SearchableDropdown_DropdownToggle__3DFyP .SearchableDropdown_DropdownTriangle__2Si7r {\n      padding: 8px 12px; }\n  .SearchableDropdown_SearchableDropdown__37P4d .SearchableDropdown_Dropdown__3lbyP {\n    position: absolute;\n    background: #fff;\n    border-bottom-right-radius: 3px;\n    border-bottom-left-radius: 3px;\n    border: 1px solid #d0d0d0;\n    border-top: none;\n    left: -1px;\n    top: 32px;\n    width: 202px;\n    box-sizing: border-box;\n    z-index: 100; }\n    .SearchableDropdown_SearchableDropdown__37P4d .SearchableDropdown_Dropdown__3lbyP .SearchableDropdown_SearchBar__2dpYE {\n      border-bottom: 1px solid #d0d0d0;\n      width: 100%; }\n      .SearchableDropdown_SearchableDropdown__37P4d .SearchableDropdown_Dropdown__3lbyP .SearchableDropdown_SearchBar__2dpYE input {\n        border: none;\n        width: 100%;\n        padding: 6px; }\n    .SearchableDropdown_SearchableDropdown__37P4d .SearchableDropdown_Dropdown__3lbyP .SearchableDropdown_DropdownOptions__epy0z {\n      max-height: 200px;\n      overflow: auto; }\n      .SearchableDropdown_SearchableDropdown__37P4d .SearchableDropdown_Dropdown__3lbyP .SearchableDropdown_DropdownOptions__epy0z .SearchableDropdown_DropdownOption__2Inzc {\n        padding: 8px; }\n        .SearchableDropdown_SearchableDropdown__37P4d .SearchableDropdown_Dropdown__3lbyP .SearchableDropdown_DropdownOptions__epy0z .SearchableDropdown_DropdownOption__2Inzc:hover {\n          background: #dee0ff; }\n";
var css$a = {
  "SearchableDropdown": "SearchableDropdown_SearchableDropdown__37P4d",
  "DropdownTriangle": "SearchableDropdown_DropdownTriangle__2Si7r",
  "DropdownToggle": "SearchableDropdown_DropdownToggle__3DFyP",
  "Placeholder": "SearchableDropdown_Placeholder__ltKFz",
  "Dropdown": "SearchableDropdown_Dropdown__3lbyP",
  "SearchBar": "SearchableDropdown_SearchBar__2dpYE",
  "DropdownOptions": "SearchableDropdown_DropdownOptions__epy0z",
  "DropdownOption": "SearchableDropdown_DropdownOption__2Inzc"
};
styleInject(css$9);

var SearchableDropdown =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchableDropdown, _Component);

  function SearchableDropdown() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SearchableDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SearchableDropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dropdownShown: false,
      searchFilter: ''
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDropdown", function (event) {
      if (event.type === "blur" && event.currentTarget.contains(event.relatedTarget)) return;

      if (event.type === "blur") {
        return _this.setState({
          dropdownShown: false
        });
      }

      _this.setState({
        dropdownShown: !_this.state.dropdownShown
      });
    });

    _defineProperty(_assertThisInitialized(_this), "search", function (_ref) {
      var value = _ref.target.value;
      return _this.setState({
        searchFilter: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectOption", function (value) {
      return function (event) {
        _this.toggleDropdown(event);

        if (_this.props.onChange) {
          _this.props.onChange(value);
        }
      };
    });

    return _this;
  }

  _createClass(SearchableDropdown, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$placehold = _this$props.placeholder,
          placeholder = _this$props$placehold === void 0 ? 'Select...' : _this$props$placehold,
          options = _this$props.options,
          styleOverrides = _this$props.styleOverrides,
          value = _this$props.value;
      var _this$state = this.state,
          dropdownShown = _this$state.dropdownShown,
          searchFilter = _this$state.searchFilter;
      var accessStyles = accessKeyOfNullable(styleOverrides, null, {});
      var shownOptions = options.filter(function (_ref2) {
        var name = _ref2.name;
        if (searchFilter === '') return true;
        return name.toLowerCase().includes(searchFilter);
      });
      return React.createElement("div", {
        className: css$a.SearchableDropdown,
        onBlur: this.toggleDropdown,
        tabIndex: 0,
        "data-open": dropdownShown,
        style: accessStyles('SearchableDropdown')
      }, React.createElement("div", {
        className: css$a.DropdownToggle,
        onClick: this.toggleDropdown
      }, React.createElement("p", {
        className: css$a.Placeholder
      }, value || placeholder), React.createElement("div", {
        className: css$a.DropdownTriangle
      }, React.createElement("div", null, "\u25BE"))), dropdownShown && React.createElement("div", {
        className: css$a.Dropdown
      }, React.createElement("div", {
        className: css$a.SearchBar
      }, React.createElement("input", {
        type: "text",
        onChange: this.search,
        placeholder: "Search..."
      })), React.createElement("div", {
        className: css$a.DropdownOptions
      }, shownOptions.map(function (_ref3) {
        var name = _ref3.name,
            value = _ref3.value;
        return React.createElement("div", {
          className: css$a.DropdownOption,
          onClick: _this2.selectOption(value)
        }, name);
      }))));
    }
  }]);

  return SearchableDropdown;
}(Component);

var css$b = ".HiddenInput_HiddenInput__1NXDY {\n  width: 100%;\n  border: 1px solid transparent; }\n  .HiddenInput_HiddenInput__1NXDY[data-hidden=\"false\"] {\n    border-color: #5b66ff;\n    background: #fff; }\n  .HiddenInput_HiddenInput__1NXDY input {\n    width: 100%;\n    border: none;\n    background: transparent;\n    padding: 6px;\n    color: #000;\n    cursor: text;\n    text-align: inherit; }\n  .HiddenInput_HiddenInput__1NXDY .HiddenInput_ErrorText__2rrGC {\n    color: #FF6961;\n    font-size: 10px; }\n";
var css$c = {
  "HiddenInput": "HiddenInput_HiddenInput__1NXDY",
  "ErrorText": "HiddenInput_ErrorText__2rrGC"
};
styleInject(css$b);

var HiddenInput =
/*#__PURE__*/
function (_Component) {
  _inherits(HiddenInput, _Component);

  function HiddenInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, HiddenInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HiddenInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hidden: true,
      showError: false
    });

    _defineProperty(_assertThisInitialized(_this), "debounceTimeout", null);

    _defineProperty(_assertThisInitialized(_this), "inputRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "debouncedDoubleClick", function () {
      if (_this.debounceTimeout) {
        _this.setState({
          hidden: false,
          showError: false
        }, function () {
          return _this.inputRef.current.focus();
        });
      } else {
        _this.debounceTimeout = setTimeout(function () {
          clearTimeout(_this.debounceTimeout);
          _this.debounceTimeout = null;
        }, 1000);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "detectEscape", function (e) {
      if (e.charCode === 13 || e.charCode === 27) {
        e.preventDefault();
        e.stopPropagation();

        _this.setState({
          hidden: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "hideInput", function () {
      return _this.setState({
        hidden: true,
        showError: true
      });
    });

    return _this;
  }

  _createClass(HiddenInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.autoFocus) {
        this.setState({
          hidden: false
        }, function () {
          return _this2.inputRef.current.focus();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          value = _this$props.value,
          onChange = _this$props.onChange,
          placeholder = _this$props.placeholder,
          _this$props$isValid = _this$props.isValid,
          isValid = _this$props$isValid === void 0 ? true : _this$props$isValid,
          errorMessage = _this$props.errorMessage;
      var _this$state = this.state,
          hidden = _this$state.hidden,
          showError = _this$state.showError;
      return React.createElement("div", {
        className: css$c.HiddenInput,
        "data-hidden": hidden,
        onClick: this.debouncedDoubleClick,
        onBlur: this.hideInput
      }, React.createElement("input", {
        title: "Double-click to edit",
        placeholder: placeholder,
        tabIndex: 34,
        ref: this.inputRef,
        type: type,
        value: value,
        onChange: onChange,
        disabled: hidden,
        onKeyPress: this.detectEscape,
        onKeyDown: this.detectEscape,
        autoFocus: true
      }), !isValid && showError && React.createElement("p", {
        className: css$c.ErrorText
      }, errorMessage));
    }
  }]);

  return HiddenInput;
}(Component);

var combineCargoReducers = function combineCargoReducers(initialReducers) {
  return combineReducers(_objectSpread2({}, initialReducers, {
    cargo: cargoReducer
  }));
};

export { Button, Card, CargoContext, CollapsibleCard, Documentation, HiddenInput, LayeredModal$1 as LayeredModal, SearchableDropdown, Table, combineCargoReducers, popModalLayer, pushModalLayer, toggleModal, updateModalLayerContent };